import React, { useState, useEffect, useRef, useContext, useMemo } from "react";
import { FiTrash2 } from "react-icons/fi";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../HandleHttpErrors";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Row, Col, Spinner, Modal } from "react-bootstrap";
import JoditEditor from "jodit-react";
import { MdLiveHelp } from "react-icons/md";
import HelpModal from "../shared/HelpModal";
import HelpContext from "../shared/context/HelpProvider";

function addMinutes(time, minutes) {
  const [hours, minutesString, seconds] = time.split(":").map(Number);
  const totalMinutes = hours * 60 + Number(minutes) + minutesString;
  const newHours = Math.floor(totalMinutes / 60);
  const newMinutes = totalMinutes % 60;
  return `${newHours.toString().padStart(2, "0")}:${newMinutes
    .toString()
    .padStart(2, "0")}`;
}

function HazmanatMoamadeem({
  visible,
  mekhraz_id,
  meetingTime,
  meeting,
  mekhraz_num,
  mekhraz_title,
}) {
  const { showHelp, setShowHelp, saeef, setSaeef } = useContext(HelpContext);
  const [activeMoamadeem, setActiveMoamadeem] = useState([]);
  const [selectedMoamadeem, setSelectedMoamadeem] = useState([]);
  const [selectedItem, setSelectedItem] = useState("");
  const [selectedMoamad, setSelectedMoamad] = useState({});
  const [timeToStart, setTimeToStart] = useState(meeting.minute_to_start);
  const [interval, setInterval] = useState(meeting.interval);
  const [activeMoamadeemWithTime, setActiveMoamadeemWithTime] = useState([]);
  const axiosPrivate = useAxiosPrivate("application/json");
  const [shouldBlink, setShouldBlink] = useState(true);
  const [remarks, setRemarks] = useState("");
  const [loading, setLoading] = useState(true);
  const [showAdd, setShowAdd] = useState(false);
  const [hafsakaId, setHafsakaId] = useState(-1);
  const [selectAll, setSelectAll] = useState(false);

  const editor1 = useRef(null);
  const config = useMemo(
    () => ({
      readonly: false,
      height: 400,
      width: 600,
      askBeforePasteFromWord: false,
      askBeforePasteHTML: false,
      toolbarAdaptive: false,
      disablePlugins: ["File", "Image", "Media"],
      //colorPickerDefaultTab: "background",
      //buttons: ["brush"],
    }),
    []
  );

  useEffect(() => {
    let isMounted = true;
    let activeMoamadeemWithTime2 = null;
    let activeMoamadeemTemp = null;
    const controller = new AbortController();

    const fetchData = async () => {
      try {
        const response1 = await axiosPrivate.get(
          "/jobs/moamadinterview?bhina_id=" + meeting.id,
          { signal: controller.signal }
        );

        if (isMounted) {
          activeMoamadeemWithTime2 = response1.data.map((item, index) => ({
            ...item,
            hazmanaId: item.id,
            selected: true,
            f_name: item.f_name ? item.f_name : "הפסקה",
            moamad_id: item.moamad_id ? item.moamad_id : null,
            father_name: item.father_name ? item.father_name : " ",
            l_name: item.l_name ? item.l_name : " ",
            dragItem: "drag" + index,
            address: meeting.address,
            hazmanaDate: item.summons_date,
            hazmanaTime: addMinutes(item.summons_time, 0),
          }));

          const response2 = await axiosPrivate.get(
            "/jobs/simplemoamad?mekhraz_id=" + mekhraz_id,
            { signal: controller.signal }
          );

          activeMoamadeemTemp = response2.data.filter((item) => item.saf);
          setActiveMoamadeem(activeMoamadeemTemp);
          setActiveMoamadeemWithTime(activeMoamadeemTemp);
        }
      } catch (error) {
        console.error(error);
        // Handle error or navigate if needed
      }
    };

    fetchData().then(() => {
      setActiveMoamadeemWithTime(
        activeMoamadeemWithTime2?.sort((a, b) =>
          a.hazmanaTime > b.hazmanaTime ? 1 : -1
        )
      );

      if (activeMoamadeemWithTime2?.length == 0) {
        setActiveMoamadeemWithTime(activeMoamadeemTemp);
      }
      // Perform any further actions that depend on the updated state
    });
    setLoading(false);
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  const handleIntervalChange = (event) => {
    setInterval(event.target.value);
  };

  const handleTimeToStartChange = (event) => {
    setTimeToStart(event.target.value);
  };

  const handleScheduleInterviews = () => {
    const activeMoamadeemWithTime1 = activeMoamadeemWithTime?.map(
      (item, index) => ({
        ...item,
        hazmanaId: item.hazmanaId ? item.hazmanaId : null,
        selected: item.selected,
        f_name: item.f_name,
        father_name: item.father_name,
        l_name: item.l_name,
        moamad_id: item.moamad_id,
        dragItem: "drag" + index,
        address: meeting.address,
        hazmanaDate: meeting.mt_date,
        hazmanaTime: addMinutes(
          meetingTime,
          Number(timeToStart) + index * interval
        ),
      })
    );
    setActiveMoamadeemWithTime(activeMoamadeemWithTime1);
    setShouldBlink(false);
  };

  const addBreak = () => {
    setHafsakaId((prev) => prev - 1);
    const newBreak = {
      hazmanaId: null,
      id: -1,
      f_name: "הפסקה",
      father_name: "",
      l_name: "",
      moamad_id: null,
      selected: false,
      dragItem: "drag" + String(hafsakaId),
      hazmanaTime: addMinutes(meetingTime, Number(timeToStart) - interval),
    };
    setActiveMoamadeemWithTime([newBreak, ...activeMoamadeemWithTime]);
  };
  const handleRowSelect = (item) => {
    if (selectedMoamadeem.includes(item)) {
      setSelectedMoamadeem(
        selectedMoamadeem.filter((selectedItem) => selectedItem !== item)
      );
    } else {
      setSelectedMoamadeem([...selectedMoamadeem, item]);
    }
  };

  const onDragEnd = (result) => {
    if (!result.destination) return;
    const { source, destination } = result;
    const items = Array.from(activeMoamadeemWithTime);
    const [removed] = items.splice(source.index, 1);
    items.splice(destination.index, 0, removed);
    setActiveMoamadeemWithTime(items);
    setShouldBlink(true);
  };
  const [selectedOption, setSelectedOption] = useState("hebrew");
  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    let isMounted = true;
    let moamadeemList = {
      list: activeMoamadeemWithTime,
      lang: selectedOption,
      notes1: meeting.hazmana_notes,
      notes2: remarks,
      mekhraz_id: mekhraz_id,
      meeting: meeting,
      timeToStart: timeToStart,
      interval: interval,
      mekhraz_num: mekhraz_num,
      mekhraz_title: mekhraz_title,
    };
    const controller = new AbortController();
    const sendEmails = async () => {
      try {
        const response = await axiosPrivate.post(
          "/jobs/sendhazmnatomoamadeem/",
          moamadeemList,
          {
            signal: controller.signal,
          }
        );
        console.log("Dont delete1");

        //isMounted && setRefreshMoamads((prev) => !prev);

        alert(
          "הפעולה בוצעה בהצלחה, כדי לוודא שהמילים נשלחו, נא לבדוק את תיבת המייל של השולח."
        );
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert("שגיאה: המיליים לא נשלחו");
          console.log(err.request);
        } else {
          console.log(err);
          alert("שגיאה: המיליים לא נשלחו");
        }
      }
      setLoading(false);
    };
    sendEmails();

    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  };

  const removeExaminee = (dragItem) => {
    const updatedArray = activeMoamadeemWithTime.filter(
      (obj) => obj.dragItem !== dragItem
    );
    setActiveMoamadeemWithTime(updatedArray);
  };

  const addExaminee = (addExaminee) => {
    const newIndex = activeMoamadeemWithTime.length;
    const newExaminee = {
      hazmanaId: null,
      id: null, //item.id,
      selected: true,
      f_name: selectedMoamad.f_name, //item.f_name,
      father_name: selectedMoamad.father_name, // item.father_name,
      l_name: selectedMoamad.l_name, //item.l_name,
      moamad_id: selectedMoamad.id,
      dragItem: "drag" + newIndex,
      address: selectedMoamad.address, //meeting.address,
      hazmanaDate: meeting.mt_date,
      hazmanaTime: addMinutes(meetingTime, -60),
    };
    setActiveMoamadeemWithTime([newExaminee, ...activeMoamadeemWithTime]);
    setShowAdd(false);
  };

  const handleSelectChange = (event) => {
    setSelectedItem(event.target.value);
    setSelectedMoamad(
      activeMoamadeem.find((obj) => obj.id === parseInt(event.target.value))
    );
  };

  const handleSelectAllChange = (event) => {
    const isChecked = event.target.checked;
    setSelectAll(isChecked);

    const updatedMoamadeem = activeMoamadeemWithTime.map((item) => ({
      ...item,
      selected: isChecked,
    }));

    // Assuming you have a state to store the array
    setActiveMoamadeemWithTime(updatedMoamadeem);
  };

  if (!visible) return;
  if (!meeting) {
    alert("הישיבה טרם הוגדרה!!!");
    return;
  }
  if (loading) {
    // Render a spinner while the data is loading
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="text-center">
          <Spinner animation="border" variant="danger" visible />
          <br />
          <h3 className="spinnerText">המתן עד סיום הפעולה.</h3>
          <br />
          <h4 className="spinnerText">
            נא זכור לבדוק את תיבת המייל של השולח -של המשתמש- על מנת לוודא
            שהמיילים אכן נשלחו.
          </h4>
        </div>
      </div>
    );
  } else {
    return (
      <>
        <HelpModal />
        <div style={{ paddingRight: "60px" }}>
          <br />
          <br />
          <Row>
            <Col>
              <h3
                onClick={() => {
                  setSaeef("25-א");
                  setShowHelp(true);
                }}
              >
                קביעת לו"ז ראיונות
                <span className="help">
                  <MdLiveHelp />
                </span>
              </h3>
              <h4>
                הישיבה תתקים ביום {meeting.mt_date} בשעה{" "}
                {meetingTime.substring(0, 5)}
              </h4>
              <br />
              <Row style={{ maxWidth: "450px" }}>
                <Col className="spinnerText">זמן לתחילת הראיונות (דקות):</Col>
                <Col>
                  <input
                    type="number"
                    id="timeToStart"
                    name="timeToStart"
                    value={timeToStart}
                    onChange={handleTimeToStartChange}
                  />
                </Col>
              </Row>
              <Row style={{ maxWidth: "450px" }}>
                <Col className="spinnerText">אורך כל ראיון (דקות):</Col>
                <Col>
                  <input
                    type="number"
                    id="interval"
                    name="interval"
                    value={interval}
                    onChange={handleIntervalChange}
                  />
                </Col>
              </Row>
              <div>
                <button
                  className="btn btn-success"
                  style={{ marginRight: "15px" }}
                  onClick={() => setShowAdd(true)}
                >
                  {" "}
                  הוספת נבחן
                </button>
                <button
                  className="btn btn-warning"
                  style={{ marginRight: "15px" }}
                  onClick={addBreak}
                >
                  {" "}
                  הוספת הפסקה
                </button>
                <button
                  onClick={handleScheduleInterviews}
                  style={{ marginRight: "15px" }}
                  className={`btn btn-danger ${
                    shouldBlink ? "blinking-button" : ""
                  }`}
                >
                  קביעת לו"ז
                </button>
              </div>

              <br />
              <div
                style={{
                  color: "black",
                  fontWeight: "bold",
                  paddingRight: "35px",
                  borderRight: "0px solid white", // Corrected this line
                }}
              >
                {"---"}
                {activeMoamadeemWithTime?.length} מוזמנים מתוך{" "}
                {activeMoamadeem?.length} מועמדים שעמדו בתנאי הסף.{"---"}
              </div>
              <div
                style={{
                  padding: "8px 16px",
                  alignItems: "center",
                  color: "red",
                  fontSize: "15px",
                  fontWeight: "bold",
                }}
              >
                <input
                  type="checkbox"
                  checked={selectAll}
                  onChange={handleSelectAllChange}
                  style={{
                    width: "15px" /* Adjust the width */,
                    height: "15px" /* Adjust the height */,

                    cursor: "pointer",
                    marginRight: "4px" /* Adjust the spacing */,
                  }}
                />{" "}
                בחר הכל{" "}
                <label style={{ color: "red" }}>
                  {"---"}
                  סמן את הנבחנים לשליחת דואר אלקטרוני {"---"}
                </label>
              </div>
              <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="droppable">
                  {(provided) => (
                    <div ref={provided.innerRef} {...provided.droppableProps}>
                      {activeMoamadeemWithTime?.map((item, index) => (
                        <Draggable
                          key={item.dragItem}
                          index={index}
                          draggableId={item.dragItem}
                        >
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={{
                                // default item style
                                padding: "8px 16px",
                                // backgroundColor: "lightblue",
                                borderColor: "blue",
                                border: "1px solid black",
                                maxWidth: "450px",
                                borderRadius: "8px",
                                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                                transition: "background-color 0.2s ease-in-out",
                                // additional styles
                                display: "flex",
                                alignItems: "center",
                                color: "brown",
                                fontSize: "20px",
                                fontWeight: "bold",
                                margin: "1px",
                                // default drag style
                                ...provided.draggableProps.style,
                                // customized drag style
                                ...(snapshot.isDragging
                                  ? { background: "pink", borderRadius: "6px" }
                                  : {}),
                              }}
                            >
                              <span
                                style={{
                                  color:
                                    item.f_name === "הפסקה" ? "blue" : "brown",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  id="selected"
                                  name="selected"
                                  checked={item.selected}
                                  hidden={item.f_name == "הפסקה" ? true : false}
                                  onChange={() => {
                                    const updatedItems = [
                                      ...activeMoamadeemWithTime,
                                    ];
                                    updatedItems[index].selected =
                                      !item.selected;
                                    setActiveMoamadeemWithTime(updatedItems);
                                    setSelectAll(false);
                                  }}
                                  style={{ transform: "scale(1.25)" }}
                                />{" "}
                                {"---"}
                                <label
                                  style={{
                                    padding: "5px",
                                    color: "red",
                                    fontSize: "20px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => removeExaminee(item.dragItem)}
                                >
                                  {"  "}
                                  <FiTrash2 />
                                  {"  "}
                                </label>
                                {"- " + item.hazmanaTime
                                  ? item.hazmanaTime
                                  : ""}
                                {"- " +
                                  item.f_name +
                                  " " +
                                  (item.father_name
                                    ? item.father_name + " "
                                    : "") +
                                  " " +
                                  item.l_name}
                              </span>{" "}
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </Col>
            <Col
              className="text-center"
              style={{
                border: "1px solid black",
                padding: "10px",
              }}
            >
              <h4
                onClick={() => {
                  setSaeef("1001");
                  setShowHelp(true);
                }}
              >
                שליחת הזמנות
                <span className="help">
                  <MdLiveHelp />
                </span>
              </h4>
              <form onSubmit={handleSubmit}>
                <label>
                  <input
                    type="radio"
                    id="hebrewR"
                    value="hebrew"
                    checked={selectedOption === "hebrew"}
                    onChange={handleOptionChange}
                  />
                  עברית
                  <input
                    style={{ marginRight: "15px" }}
                    type="radio"
                    id="arabicR"
                    value="arabic"
                    checked={selectedOption === "arabic"}
                    onChange={handleOptionChange}
                  />
                  ערבית
                </label>
                <label>הערות לצרף בסוף ההזמנה</label>

                <JoditEditor
                  editorRef={editor1}
                  name="remarks"
                  tabIndex={1}
                  value={remarks}
                  config={config}
                  onBlur={(newContent) => {
                    setRemarks(newContent);
                    //hiddenButton.current.focus();
                  }}
                />

                <button
                  type="submit"
                  disabled={shouldBlink}
                  style={{ marginRight: "15px" }}
                  className={"btn btn-warning "}
                >
                  שמירה ושליחה
                </button>
              </form>
            </Col>
          </Row>
        </div>
        <Modal
          show={showAdd}
          onHide={() => setShowAdd(false)}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>{"הוספת מועמד לרשימת המרואינים"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group">
              <label htmlFor="newExaminee">סוג הפרסום</label>
              <br />
              <select
                name="newExaminee"
                onChange={handleSelectChange}
                value={selectedItem}
              >
                <option value="" selected>
                  בחר מועמד
                </option>
                {activeMoamadeem?.map((a) => (
                  <option key={a.id} value={a.id}>
                    {a.f_name +
                      " " +
                      (a.father_name ? a.father_name + " " : "") +
                      " " +
                      a.l_name +
                      " " +
                      a.idz}
                  </option>
                ))}
              </select>
            </div>
            <button className="btn btn-success" onClick={addExaminee}>
              הוסף
            </button>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default HazmanatMoamadeem;
